export default "__VITE_ASSET__CCWDsu1W__";